
import * as Cesium from "cesium";
import { useEffect, useRef } from "react";
import { createNaturalEarthProvider, offline, setup_gs_hover } from "../../../../utils/commonFunctions";
import useViewer from "../hooks/useViewer";
import useNavigation from "../hooks/useNavigation";


const ViewerProvider = ({ children }: { children: React.ReactNode }) => {
    const { scenarioId, resetViewerMode } = useNavigation()
    const { viewer, setViewer } = useViewer()
    const gsHoverHandlerRef = useRef<Cesium.ScreenSpaceEventHandler | null>(null)

    const Imaginary = new Cesium.MapboxStyleImageryProvider({
        styleId: 'dark-v10',
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN!
    });
    const inertiaZoomValue = 40000000;
    const maximumZoomDistanceValue = 35500000;
    useEffect(() => {
        const container = document.getElementById('scenariocesiumContainer');
        if (container && container.children.length > 0) {
            return; // Prevent creating a new viewer if one already exists
        }
        const cesium_viewer = new Cesium.Viewer('scenariocesiumContainer', {
            requestRenderMode: true,
            shouldAnimate: true,
            animation: false, // Disable the default animation widget
            baseLayerPicker: false, // Disable the default base layer picker
            timeline: false, // Disable the timeline
            geocoder: false, // Disable the geocoder
            homeButton: false, // Disable the home button
            navigationHelpButton: false, // Disable the navigation help button
            sceneModePicker: false, // Disable the scene mode picker
            selectionIndicator: false, // Disable the selection indicator
            fullscreenButton: false,
            imageryProvider: offline() ? createNaturalEarthProvider() : Imaginary,
        });

        cesium_viewer.scene.morphTo2D(0);
        cesium_viewer.scene.globe.enableLighting = true
        cesium_viewer.scene.screenSpaceCameraController.inertiaZoom = inertiaZoomValue;
        cesium_viewer.scene.screenSpaceCameraController.maximumZoomDistance = maximumZoomDistanceValue;
        var imaginary = new Cesium.MapboxStyleImageryProvider({
            styleId: 'dark-v10',
            accessToken: process.env.REACT_APP_MAPBOX_TOKEN!
        });
        cesium_viewer.imageryLayers.addImageryProvider(offline() ? createNaturalEarthProvider() : imaginary);
        cesium_viewer.scene.globe.showGroundAtmosphere = false;
        cesium_viewer.clock.shouldAnimate = true;
        cesium_viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        cesium_viewer.scene.screenSpaceCameraController.enableRotate = true;
        cesium_viewer.scene.screenSpaceCameraController.enableZoom = true;
        cesium_viewer.scene.screenSpaceCameraController.enableTilt = true;
        cesium_viewer.scene.screenSpaceCameraController.enableLook = true;
        cesium_viewer.scene.highDynamicRange = false;
        cesium_viewer.scene.skyAtmosphere.show = false;
        resetViewerMode()
        setViewer(cesium_viewer)
        gsHoverHandlerRef.current = setup_gs_hover(cesium_viewer, 'GS_OBJECT')
        return () => {
            gsHoverHandlerRef.current?.destroy()
            gsHoverHandlerRef.current = null
        }
    }, [])

    useEffect(() => {
        if (!viewer) return
        const map_details = JSON.parse(sessionStorage.getItem('map_details') || '{}');
        if (scenarioId && map_details?.[scenarioId] && map_details?.[scenarioId]?.View === '3D') return
        setTimeout(() => {
            viewer && viewer.scene.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(0, 0, 35500000),
                orientation: {
                    heading: Cesium.Math.toRadians(0.0),
                    pitch: Cesium.Math.toRadians(0.0),
                    roll: Cesium.Math.toRadians(0.0)
                }
            });
        }, 1000)
    }, [viewer, scenarioId])

    return children;
}

export default ViewerProvider